// noinspection JSCheckFunctionSignatures
import React from 'react'

import { paths } from 'mmfintech-backend-api'

const Deposit = React.lazy(() => import('@views/Deposit'))
const CardDetails = React.lazy(() => import('@views/CardDetails'))
const Challenge = React.lazy(() => import('@views/Challenge'))
const Withdrawal = React.lazy(() => import('@views/Withdrawal'))


// prettier-ignore
const routes = [
  { path: paths.banking.deposit(), PrivateComponent: Deposit, redirect: '' },
  { path: '/view', PrivateComponent: CardDetails, redirect: '' },
  { path: '/challenge', PrivateComponent: Challenge, redirect: '' },
  { path: '/withdrawal', PrivateComponent: Withdrawal, redirect: '' },
]

export { routes }
